import { useCallback, useEffect, useState } from 'react';
import { parseRwaCatalog, RWA_CATALOG_URL } from '../lib/catalog.js';

const initialState = {
  status: 'loading',
  programs: [],
  meta: null,
  error: null,
  errorCode: null,
};

export function useRwaCatalog() {
  const [state, setState] = useState(initialState);
  const [attempt, setAttempt] = useState(0);

  const retry = useCallback(() => setAttempt((value) => value + 1), []);

  useEffect(() => {
    const controller = new AbortController();
    setState((current) => ({ ...current, status: 'loading', error: null, errorCode: null }));
    fetch(RWA_CATALOG_URL, { signal: controller.signal })
      .then(async (response) => {
        const payload = await response.json().catch(() => null);
        if (!response.ok) {
          const error = new Error(payload?.error || `Catalog feed returned HTTP ${response.status}.`);
          error.code = payload?.code || null;
          throw error;
        }
        return payload;
      })
      .then((payload) => setState({ status: 'ready', error: null, errorCode: null, ...parseRwaCatalog(payload) }))
      .catch((error) => {
        if (error.name !== 'AbortError') {
          setState((current) => ({ ...current, status: 'error', error: error.message, errorCode: error.code || null }));
        }
      });
    return () => controller.abort();
  }, [attempt]);

  return { ...state, retry };
}
